import { useEffect } from "react";

export function useClassicRoomSocket(
  socket,
  roomName,
  setNumPrompts,
  setWaitingForPrompts,
  setGameStarted,
  setInGameLength,
) {
  useEffect(() => {
    const onRoomState = (msg) => {
      setNumPrompts(msg.promptCount);
      setWaitingForPrompts(!!msg.isGenerating);
      if (setGameStarted) setGameStarted(msg.gameStarted);
      if (setInGameLength) setInGameLength(msg.inGameLength ?? 0);
    };

    socket.on("classic room state", onRoomState);

    socket.emit("join room", roomName);

    return () => {
      socket.off("classic room state", onRoomState);
    };
  }, [
    socket,
    roomName,
    setNumPrompts,
    setWaitingForPrompts,
    setGameStarted,
    setInGameLength,
  ]);
}
